export type StandardErrorResponse = {
    status: number;
    type: string;
    title: string;
    detail: string;
};

export type ValidationExceptionResponse = Omit<StandardErrorResponse, 'status' | 'detail'> & {
    details: string;
    context: {
        violations: Array<{
            field: string;
            message: string;
        }>
    }
};

export type ErrorResponse = StandardErrorResponse | ValidationExceptionResponse;

export const isStandardErrorResponse = (data: ErrorResponse):
    data is StandardErrorResponse => typeof data === 'object' && 'detail' in data;

export const isValidationExceptionResponse = (data: ErrorResponse):
    data is ValidationExceptionResponse => typeof data === 'object' && 'context' in data;
